
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/global-recruitment",
      function () {
        return require("private-next-pages/services/global-recruitment.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/global-recruitment"])
      });
    }
  